import { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";

interface Props {
  children: ReactNode;
  link?: string;
  onClick?: () => void;
  enabled?: boolean;
}

const PrimaryButton = ({ children, link, onClick, enabled = true }: Props) => {
  const [clicked, setClicked] = useState(false);
  const nav = useNavigate();

  return (
    <button
      className={`primary ${clicked ? "clicked" : ""} ${
        !enabled ? "disabled" : ""
      }`}
      onClick={() =>
        enabled &&
        setTimeout(
          () => (onClick?.() ?? link !== undefined ? nav(link!) : () => {}),
          100
        )
      }
      onPointerDown={() => enabled && setClicked(true)}
      onPointerUp={() => setTimeout(() => enabled && setClicked(false), 100)}
      onPointerLeave={() => enabled && setClicked(false)}
    >
      <p>{children}</p>
    </button>
  );
};

export default PrimaryButton;
